import React from "react";

function formatDate(dateString, type) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date = new Date(dateString);
  const monthName = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const timezone = Intl.DateTimeFormat(undefined, {
    timeZoneName: "short",
  }).format(date);

  const timeArray = timezone?.split(",");
  const zoneArray = timeArray[1]?.split("+");

  const formattedDate = `${monthName} ${day}, ${year}`;
  const formattedTimezone = `  ${hours}:${minutes} ${
    zoneArray[0] ? zoneArray[0] : ""
  }`;

  if (type == "date") {
    const formattedDateTimezone = `${formattedDate}`;
    return formattedDateTimezone;
  } else {
    const formattedDateTimezone = `${formattedDate}  ${formattedTimezone}`;
    return formattedDateTimezone;
  }
}

const Maintenance = ({ data }) => {
  return (
    <div>
      <div>
        <br /> <br />
        <h1 style={{ fontSize: "1.5rem", fontWeight: "600" }}>
          Scheduled Maintenance
        </h1>
      </div>
      {data?.data?.data?.maintenances?.map((maintenance, i) => (
        <div
          className="mt-6 flex flex-col space-y-4 "
          style={{ paddingRight: "3rem" }}
          key={i}
        >
          <div className="bg-white dark:bg-slate-900 rounded-lg px-6 py-6 ring-1 ring-slate-900/5 shadow-sm border-2 border-t-orange-500">
            <span className="inline-flex items-right justify-right p-2 bg-red-500 rounded-md shadow-sm text-white mt-5">
              {maintenance?.name}
            </span>
            <span style={{ float: "right" }}>
              Scheduled for {formatDate(maintenance?.scheduledStart)} - {""}
              {formatDate(maintenance?.scheduledEnd)}
            </span>
            <br />
            <br /> <hr />
            {maintenance?.updates?.map((update, k) => {
              const formattedDateTimezone = formatDate(update?.happenedAt);
              return (
                <div key={k}>
                  <br />
                  <div>
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                      }}
                      className="text-slate-900 dark:text-white mt-5 text-base font-medium tracking-tight"
                    >
                      {update.status.label}
                    </span>
                    {update?.message && <span> - {update?.message}</span>}
                  </div>
                  <span style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                    Posted on {formattedDateTimezone}
                  </span>
                  <br />
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Maintenance;
